type QualityCriterionLike = {
  bool?: boolean | null;
  value?: boolean | null;
};

type RankedPredictionLike = {
  qualityPercentage?: number | null;
  afScore?: number | null;
  confidenceScore?: number | null;
  frameIndex?: number | null;
  correlation_id?: string | null;
};

const toFiniteNumber = (value: unknown): number => {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const toFrameOrder = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : Number.MAX_SAFE_INTEGER;
};

export const countPassedQualityCriteria = (
  criteria: QualityCriterionLike[] = []
): number =>
  criteria.reduce((count, criterion) => {
    const passed =
      criterion?.bool === true ||
      (criterion?.bool == null && criterion?.value === true);
    return passed ? count + 1 : count;
  }, 0);

export const compareRankedPredictions = (
  a: RankedPredictionLike,
  b: RankedPredictionLike
): number => {
  const qualityDiff =
    toFiniteNumber(b.qualityPercentage) - toFiniteNumber(a.qualityPercentage);
  if (qualityDiff !== 0) {
    return qualityDiff;
  }

  const afDiff = toFiniteNumber(b.afScore) - toFiniteNumber(a.afScore);
  if (afDiff !== 0) {
    return afDiff;
  }

  const confidenceDiff =
    toFiniteNumber(b.confidenceScore) - toFiniteNumber(a.confidenceScore);
  if (confidenceDiff !== 0) {
    return confidenceDiff;
  }

  const frameOrderDiff = toFrameOrder(a.frameIndex) - toFrameOrder(b.frameIndex);
  if (frameOrderDiff !== 0) {
    return frameOrderDiff;
  }

  return String(a.correlation_id || '').localeCompare(String(b.correlation_id || ''));
};
